import {blockType, LevelData, LevelDescription} from '../data/level-data.js';
import {clone} from '../utils/clone.js';
import {BoxState} from './boxState.js';
import {storageSpace13} from '../globals.js';
import {NotifyPropertyChanged} from '../utils/NotifyPropertyChanged.js';

export class LevelState extends NotifyPropertyChanged<LevelState> {
    boxStates: BoxState[];
    possibleTargets: number[][];
    level: number | 'Title';
    currentLevelData: LevelDescription;

    constructor() {
        super();
        this.boxStates = [];
        this.possibleTargets = [];
    }

    private _availableTargets = 0;
    set availableTargets(value) {
        this._availableTargets = value;
        this.calculateTargets();
        this.notifyPropertyChanged('availableTargets');
    }
    get availableTargets() {
        return this._availableTargets;
    }

    initLevelState(level) {
        this.level = level;
        this.currentLevelData = clone(LevelData[level]) as LevelDescription;
        this.boxStates.length = 0;
        this.possibleTargets.length = 0;
    }

    getNewBoxState() {
        let boxState = new BoxState();
        // boxState.getPropertyEmitter('onTarget').add((onTarget) => {
        //     this.onTarget(boxState.onTarget);
        // });

        boxState
            .changeOnProperty('position')
            .add((newVal: [number, number, number], oldVal: [number, number, number]) => {
                if (!oldVal || oldVal[0] === null || oldVal[0] === undefined) {
                    return;
                }

                // Adjust positions
                oldVal[0] = Math.floor(oldVal[0] + this.currentLevelData.width / 2);
                oldVal[2] = Math.floor(oldVal[2] + this.currentLevelData.height / 2);
                newVal[0] = Math.floor(newVal[0] + this.currentLevelData.width / 2);
                newVal[2] = Math.floor(newVal[2] + this.currentLevelData.height / 2);

                // Handle old and new positions
                let oldValue = LevelData[this.level].layer[0].data[oldVal[0]][oldVal[2]];
                if (oldValue === 'B') {
                    oldValue = 0;
                }
                this.currentLevelData.layer[0].data[oldVal[0]][oldVal[2]] = oldValue;
                this.currentLevelData.layer[0].data[newVal[0]][newVal[2]] = 'B';
                this.calculateTargets();
            });

        this.boxStates.push(boxState);
        return boxState;
    }

    // onTarget(isOnTarget) {
    //     if (isOnTarget) {
    //         this.targetsToComplete--;
    //     } else {
    //         this.targetsToComplete++;
    //     }
    // }

    canTeleportToPosition(x: number, y: number, z: number) {
        const mapPos = {
            x: Math.floor(x + this.currentLevelData.width / 2),
            y: Math.floor(z + this.currentLevelData.height / 2),
        };
        return !!this.possibleTargets[Math.floor(mapPos.x)][Math.floor(mapPos.y)];
    }

    calculateTargets() {
        const pos = storageSpace13.gameState.playerPosition;
        const pPos = {
            x: Math.floor(pos[0] + this.currentLevelData.width / 2),
            y: Math.floor(pos[2] + this.currentLevelData.height / 2),
        };
        const cl = storageSpace13.gameState.level;
        const screen = this.currentLevelData.layer[0].data;
        this.possibleTargets = new Array(this.currentLevelData.width);
        for (let i = 0; i < this.currentLevelData.width; i++) {
            this.possibleTargets[i] = new Array<number>(this.currentLevelData.height);
            for (let j = 0; j < this.currentLevelData.height; j++) {
                this.possibleTargets[i][j] = 0;
            }
        }
        this.floodFillUtil(screen, this.possibleTargets, pPos.x, pPos.y);
    }

    floodFillUtil(sourceMap: blockType[][], targetMap: number[][], x: number, y: number, prevC = 0, newC = 1) {
        if (x < 0 || x >= this.currentLevelData.width || y < 0 || y >= this.currentLevelData.height) return;
        if (sourceMap[x][y] != prevC && sourceMap[x][y] != 'S' && sourceMap[x][y] != 'T') return;
        if (!!targetMap[x][y]) return;

        targetMap[x][y] = newC;

        // Recur for north, east, south and west
        this.floodFillUtil(sourceMap, targetMap, x + 1, y);
        this.floodFillUtil(sourceMap, targetMap, x - 1, y);
        this.floodFillUtil(sourceMap, targetMap, x, y + 1);
        this.floodFillUtil(sourceMap, targetMap, x, y - 1);
    }
}
